function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1920,
    rx: 457.53,
    ry: 457.53,
    style: {
      fill: "#ff9f5a"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m554.73,539.59c217.89-217.89,562.81-231.3,796.36-40.23,0,0-290.67,31.56-234.83,219.78,0,0-208.9,75.89-62.05,240.86-8.73,9.52-132.21,312.35,182.01,249.34,0,0-24.82,264.11,242.72,66.61-23.33,37.11-51.11,72.19-83.39,104.47-232.18,232.18-608.65,232.18-840.83,0-232.18-232.18-232.18-608.65,0-840.83Z",
    style: {
      fill: "none",
      stroke: "#240b00",
      strokeLinejoin: "round",
      strokeWidth: 62
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 649.35,
    cy: 659.53,
    rx: 60.3,
    ry: 54.05,
    transform: "translate(-135.37 1150.29) rotate(-77.47)",
    style: {
      fill: "#240b00"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 758.28,
    cy: 960,
    rx: 63.06,
    ry: 67.04,
    transform: "translate(-441.61 1198.43) rotate(-62.93)",
    style: {
      fill: "#240b00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 929.77,
    cy: 574.85,
    r: 51.4,
    style: {
      fill: "#240b00"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 960,
    cy: 1374.8,
    rx: 56.3,
    ry: 76,
    transform: "translate(-558.79 664.19) rotate(-30)",
    style: {
      fill: "#240b00"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.98,
    cy: 1240.57,
    rx: 44.06,
    ry: 50.46,
    transform: "translate(-674.47 1688.44) rotate(-80.79)",
    style: {
      fill: "#240b00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1224.37,
    cy: 896.08,
    r: 78.82,
    style: {
      fill: "none",
      stroke: "#240b00",
      strokeMiterlimit: 10,
      strokeWidth: 62
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1415.73,
    cy: 707.33,
    r: 81.07,
    style: {
      fill: "none",
      stroke: "#240b00",
      strokeMiterlimit: 10,
      strokeWidth: 62
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1443.88,
    cy: 1111.06,
    rx: 120.49,
    ry: 82.2,
    transform: "translate(-279.9 1700.83) rotate(-56.47)",
    style: {
      fill: "none",
      stroke: "#240b00",
      strokeMiterlimit: 10,
      strokeWidth: 62
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.83520d8d9c99b67435f5a250cb91b464.svg";
export { ForwardRef as ReactComponent };